import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Loader } from 'react-loaders'
import { fetchData } from '../../common/redux/collectionActions'
import { isLoggedIn } from '../Auth/redux/authActions'
import SideBarItem from './SideBarItem'
import 'loaders.css'

import { withRouter } from 'react-router'

const baseItems = ['home', 'deliveries', 'users']

class SideBar extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  goToDash() {
    if ((window.location.href = window.BASE_NAME)) {
      return (window.location.href = window.BASE_NAME)
    }
    return null
  }

  componentWillMount() {
    if (isLoggedIn()) this.props.fetchData(['admin'])
  }

  goTo = (path) => {
    if (path.startsWith('https')) window.open(path.replace(/_/g, '.'), '__blank')
    else this.props.history.push(path)
  }

  generateItems = () => {
    const { locks } = this.props
    const items = []
    const roles = this.props.admin.user.roles || []

    // skapa bas-items, dölj leveranser ifall endast kluster existerar
    for (const item of baseItems) {
      if (item === 'deliveries') {
        if (locks && locks.some((l) => l.type !== 'cluster')) {
          items.push(<SideBarItem key={item} locks={locks} label={item} goTo={this.goTo} />)
        }
      } else {
        items.push(<SideBarItem key={item} locks={locks} label={item} goTo={this.goTo} />)
      }
    }

    if (roles.length) items.push(<hr key="hr" />)

    // skapa roles-items
    for (const role of roles) {
      items.push(<SideBarItem key={role} locks={locks} label={role} goTo={this.goTo} />)
    }

    // if admin has hilti in email address, add hilti q&a
    if (this.props.admin.user.email && this.props.admin.user.email?.includes('hilti')) {
      items.push(<SideBarItem key="hilti_q&a" locks={locks} label="hilti_q&a" goTo={this.goTo} />)
    }

    let hasStorage = false
    for (const lock of locks) {
      if (lock.storage) {
        if (!hasStorage) {
          items.push(<SideBarItem key="storage_q&a" locks={locks} label="storage_q&a" goTo={this.goTo} />)
          hasStorage = true
        }
        const hasHiltiSvenskaAB = lock.storage.suppliers?.some((s) => s.name === 'Hilti Svenska AB') && this.props.admin?.user?.email?.includes('hilti')

        if (hasHiltiSvenskaAB) {
          items.push(<SideBarItem key="hilti_sv_q&a" locks={locks} label="hilti_sv_q&a" goTo={this.goTo} />)
          break
        }
      }
    }

    return items
  }

  render() {
    if (!this.props.admin || !this.props.locks.length) return <Loader type="line-scale" color="#006e78" style={{ zIndex: '9999', position: 'absolute', right: '30px', top: '10px' }} />

    return <div style={{ backgroundColor: 'white', textAlign: 'center', padding: '40px 10px 40px 10px', height: window.isMobile ? '70%' : 'auto', boxShadow: 'lightgrey 1px 1px 5px', position: 'fixed', position: 'sticky', top: 70, zIndex: 9999 }}>{this.generateItems()}</div>
  }
}

const mapStateToProps = (state) => ({
  admin: state.collectionData.admin,
  locks: state.collectionData.locks,
})

const mapDispatch = (dispatch) => ({
  fetchData: (...args) => dispatch(fetchData(...args)),
})

export default withRouter(connect(mapStateToProps, mapDispatch)(SideBar))
